<div class="errorPage-container d-flex flex-column">
    @if (sessionMissing) {
        <div class="error-page d-flex">
            <img class="error-page-image" alt="" src="/assets/images/error-pages/error-server-error.svg" />
            <div class="error-page-content">
                <h1>{{ 'SESSION_MISSING_TITLE' | translate }}</h1>
                <p>{{ 'SESSION_MISSING_TEXT' | translate }}</p>
            </div>
        </div>
    } @else {
        <app-spinner [visible]="true" infoText="SESSION_PENDING_TEXT"></app-spinner>
    }
</div>
